import React, { useState } from 'react';
import { useAppDispatch } from 'hooks';
import classNames from 'classnames';
import dayjs from 'dayjs';

import { isBeforeDay, weeklyPlannerDayDisplayFormat } from '~libs/dayjs';

import Button from '~components/Button';
import PublishDialog from '~weekly-planner/components/modal/Publish';

import { clearError } from '~appointments/reducers/appointments';

interface componentProps {
  publishDate: string;
  date: string;
  isLoading: boolean;
  onRefresh?: () => void;
}
export const PublishPill: React.FC<componentProps> = ({ date, publishDate, isLoading, onRefresh }) => {
  const dispatch = useAppDispatch();
  const clearAppointmentsError = () => dispatch(clearError());

  const [IsPublishOpen, setIsPublishOpen] = useState(false);

  const startOfWeek = dayjs(date).weekday(0);
  const endOfWeek = startOfWeek.add(6, 'days');
  const published = !isBeforeDay(dayjs(publishDate), startOfWeek);
  const partialPublish = isBeforeDay(dayjs(publishDate), endOfWeek);

  const displayDate = dayjs(publishDate).format(weeklyPlannerDayDisplayFormat);

  const publishMarkerClassName = classNames('pill publish', {
    published,
    partial: partialPublish && published,
  });

  return (
    <>
      <Button
        className={publishMarkerClassName}
        data-cy="weekly-planner-publish-status-pill"
        onClick={() => setIsPublishOpen(true)}
      >
        {isLoading ? <span>Generating published status...</span> : <span>{`Published to ${displayDate}`}</span>}
      </Button>
      <PublishDialog
        isOpen={IsPublishOpen}
        onClose={() => {
          setIsPublishOpen(false);
          onRefresh && onRefresh();
          clearAppointmentsError();
        }}
        originalDate={publishDate}
      />
    </>
  );
};

export default PublishPill;
